// extracted by mini-css-extract-plugin
module.exports = {"sectionHeadline":"FeaturedCarsSlider-module__sectionHeadline___1mT_V","ratingContainerLogo":"FeaturedCarsSlider-module__ratingContainerLogo___19sdx"};